
































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import CopyText from '@/components/misc/CopyText.vue'
import { toAVAX } from '@/helper'
import Tooltip from '@/components/rows/Tooltip.vue'
import EVMMetadata from '@/components/Block/EVMMetadata.vue'
import EVMLogRow from '@/components/rows/EVMLogRow.vue'
import TxList from '@/components/Transaction/TxList.vue'
import EVMTxDataTable from '@/components/Transaction/EVMTxDataTable.vue'

@Component({
    components: {
        Tooltip,
        CopyText,
        EVMMetadata,
        EVMTxDataTable,
        TxList,
        EVMLogRow,
    },
    filters: {
        toAVAX,
    },
})
export default class EVMTxSummary extends Vue {
    @Prop() block!: any

    copy() {
        navigator.clipboard.writeText(this.block.blockNumber)
        this.$store.dispatch('Notifications/add', {
            title: 'Copied',
            message: 'Copied to clipoard.',
        })
    }

    get tab() {
        return this.$route.query.tab
    }

    set tab(tab: string | (string | null)[]) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
    }

    get hasTxs() {
        return this.block.transactions.length > 0 ? true : false
    }

    get hasAtomicTxs() {
        return this.block.atomicTransactions.length > 0 ? true : false
    }

    get hasLogs() {
        return this.block.logs.length > 0 ? true : false
    }
}
